import {BrowserRouter as Router} from 'react-router-dom'
import { useRoutes } from './router/index'
import { AuthContext } from './context/AuthContext'
import { useAuth } from './hooks/auth.hook'
import NotificationHandler from './components/Main/NotificationHandler'

function App() {
  const { token, login, logout, userId, expire, ready } = useAuth()
  const isAuthenticated = !!token
  const routes = useRoutes(isAuthenticated)
  return (
    
    <AuthContext.Provider value={{
      token, login, logout, userId, isAuthenticated
    }}>
      <NotificationHandler isAuthenticated={isAuthenticated}/>
      <Router>
        {routes}
      </Router>
    </AuthContext.Provider>

  );
}

export default App;
